import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    drawer:{},
    data: undefined,
    aiDrawerData: undefined, // AI 요약용 { keys, startDate, endDate } (opener.data는 WidgetSettings 등 다른 용도)
};

const openerSlice = createSlice({
    name: 'opener',
    initialState,
    reducers: {
        closeDrawer(state, action) {
            const { key } = action.payload;
            document.body.style.overflow = "auto";
            if (!state.drawer.hasOwnProperty(key)) {
                state.drawer[key] = false;
            }
            state.drawer[key] = false;
            if (key === "AI") state.aiDrawerData = undefined;
        },
        openDrawer(state, action) {
            const { key } = action.payload;
            document.body.style.overflow = "hidden";
            if (!state.drawer.hasOwnProperty(key)) {
                state.drawer[key] = true;
            }
            state.drawer[key] = true;
        },toggleDrawer(state, action) {
            const { key } = action.payload;
            if (state.drawer.hasOwnProperty(key)) {
                state.drawer[key] = !state.drawer[key];
            }
        },
        openKeyAndGet(state, action) {
            const { key, data } = action.payload;
            document.body.style.overflow = "hidden";
            if (!state.drawer.hasOwnProperty(key)) {
                state.drawer[key] = true;
                state.data = data;
            }
            state.drawer[key] = true;
            state.data = data;
        },
        /** AI 요약 드로어만 열 때 사용. opener.data를 덮어쓰지 않음 (WidgetSettings 등과 공유 방지) */
        openAiDrawer(state, action) {
            const { data } = action.payload;
            document.body.style.overflow = "hidden";
            state.drawer["AI"] = true;
            state.aiDrawerData = data;
        },
        closeKeyAndFlush(state, action) {
            const { key } = action.payload;
            document.body.style.overflow = "auto";
            if (!state.drawer.hasOwnProperty(key)) {
                state.drawer[key] = false;
                state.data = undefined;
            }
            state.drawer[key] = false;
            state.data = undefined;
            if (key === "AI") state.aiDrawerData = undefined;
        }
    },
});

export const { closeDrawer, openDrawer, openKeyAndGet, openAiDrawer, closeKeyAndFlush, toggleDrawer } = openerSlice.actions;

export default openerSlice.reducer;
